import { useEffect, useState } from "react";
import { PhoneCall, Loader2, AlertCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";

/**
 * Click-to-call button. Fetches /integrations/status once to decide whether
 * Aircall is enabled for the current tenant; otherwise displays a hint.
 */
export default function AircallCallButton({ api, prospect, onCalled }) {
  const [enabled, setEnabled] = useState(null); // null = loading
  const [dialing, setDialing] = useState(false);

  useEffect(() => {
    api.get("/integrations/status")
      .then((r) => setEnabled(Boolean(r.data?.aircall_enabled)))
      .catch(() => setEnabled(false));
  // eslint-disable-next-line
  }, []);

  const phone = prospect?.phone || "";
  if (!phone) return null;

  if (enabled === false) {
    return (
      <div className="flex items-center gap-1 text-[10px] text-amber-400/80" title="Configurez Aircall dans Parametres > Integrations">
        <AlertCircle className="w-3 h-3" /> Aircall non configure
      </div>
    );
  }

  const dial = async () => {
    setDialing(true);
    try {
      const r = await api.post("/aircall/click-to-call", {
        prospect_id: prospect.prospect_id,
        phone,
      });
      toast.success(`Appel lance vers ${r.data.phone}`);
      onCalled && onCalled();
    } catch (e) {
      toast.error(e.response?.data?.detail || e.message);
    }
    setDialing(false);
  };

  return (
    <Button
      onClick={dial}
      disabled={dialing || enabled === null}
      size="sm"
      className="bg-green-500/20 text-green-300 hover:bg-green-500/30 border border-green-500/30 h-7 px-2 text-[10px] font-bold"
      data-testid="aircall-dial-btn"
    >
      {dialing ? <Loader2 className="w-3 h-3 animate-spin mr-1" /> : <PhoneCall className="w-3 h-3 mr-1" />}
      {dialing ? "Appel..." : "Appeler"}
    </Button>
  );
}
